import React, { useEffect } from "react";
import * as yup from "yup";
import { Formik, Form } from "formik";
import {
    customStringify,
    error_alert,
    setToken,
    stringNotEmpty,
    success_alert,
} from "../../utils";
import TextField from "../../components/FormikFields/TextField";
import { BiLoaderAlt } from "react-icons/bi";
import { Link } from "react-router-dom";
import { login } from "../../redux/slices/userSlice";
import { useDispatch } from "react-redux";
import { email_tl, network_tl, required_tl } from "../../translations";
import { FormattedMessage, useIntl } from "react-intl";
import useApi from "../../hooks/useApi";
import { BASE_URL, EMAIL_REGX, ROLE_ADMIN } from "../../constants";

const Login = () => {
    const intl = useIntl();
    const dispatch = useDispatch();
    const {Axios} = useApi();

    const initialValues = {
        email: "",
        password: "",
    };
    yup.addMethod(yup.string, "stringNotEmpty", stringNotEmpty);
    const validationSchema = yup.object({
        email: yup.string().email(email_tl(intl)).required(required_tl(intl)).matches(EMAIL_REGX, email_tl(intl)),
        password: yup.string().required(required_tl(intl)),
    });

    const handleSubmit = async (values, formikBag) => {
        try {
            const result = await Axios.post("api/user/user-login", values);
            // user instance
            const { access_token, role_code, ...user_info } = result.data.payload;

            if (role_code === ROLE_ADMIN.value) {
                error_alert(intl.formatMessage({ id: "unauthorized", defaultMessage: "You are not authorized to access this page." }));
                return
            }

            user_info.role = role_code;
        
            

            // token to save to local storaged
            const tokenObj = {
                user: user_info,
                access_token: access_token,
            };
            //saved to local storage
            setToken(tokenObj);

            // // set redux state
            dispatch(login(user_info));
            success_alert(result.data.description);
            // const result = await Axios.post("api/user/login", values);
            // // user instance
            // const { access_token,  ...user } = result.data.payload

            // // token to save to local storage
            // const tokenObj = {
            //     user: user,
            //     access_token: access_token,
            // };
            // //saved to local storage
            // setToken(tokenObj);

            // // // set redux state
            // dispatch(login(user));
            // success_alert(result.data.description);
        } catch (e) {
            if (e.response) {
                error_alert(customStringify(e.response.data.description))
            } else {
                error_alert(network_tl(intl));
            }
        }
    };

    return (
        <Formik
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={handleSubmit}
        >
            {(form) => (
                <Form className="mt-5 w-[90%] mx-auto">
                    <>
                        <div className="space-y-5">
                            <div>
                                <TextField
                                    type="email"
                                    field="email"
                                    label_text={
                                        <FormattedMessage
                                            id="email"
                                            defaultMessage="email"
                                        />
                                    }
                                    form={form}
                                    isRequired
                                />
                            </div>
                            <div>
                                <TextField
                                    type="password"
                                    field="password"
                                    label_text={
                                        <FormattedMessage
                                            id="password"
                                            defaultMessage={"Password"}
                                        />
                                    }
                                    form={form}
                                    password
                                    isRequired

                                />
                            </div>
                            <div className="flex items-center pt-3 pb-3">
                                <button
                                    type="submit"
                                    disabled={form.isSubmitting}
                                    className="block w-full btn btn-primary"
                                >
                                    <p>
                                        {form.isSubmitting ? (
                                            <BiLoaderAlt className="animate-spin text-white text-2xl mx-auto" />
                                        ) : (
                                            intl.formatMessage({ id: "login", defaultMessage: "Login" })
                                        )}
                                    </p>
                                </button>
                            </div>
                            <p className="text-xs md:text-sm text-center">
                                <FormattedMessage
                                    id="trouble_login"
                                    defaultMessage={
                                        "Have trouble logging in? Reset your password {link}"
                                    }
                                    values={{
                                        link: (
                                            <Link
                                                className="text-primary underline font-medium"
                                                to="/forgot-password"
                                            >
                                                <FormattedMessage id="here" defaultMessage={"here"} />
                                            </Link>
                                        ),
                                    }}
                                />
                            </p>
                            <hr className="border-gray-300" />
                            <p className="text-xs md:text-sm text-center">
                                {/* <FormattedMessage
                                    id="trouble_login"
                                    defaultMessage={
                                        "Have trouble logging in? Reset your password {link}"
                                    }
                                    values={{
                                        link: (
                                            <Link
                                                className="text-primary underline font-medium"
                                                to="/forgot-password"
                                            >
                                                <FormattedMessage id="here" defaultMessage={"here"} />
                                            </Link>
                                        ),
                                    }}
                                /> */}

                                <FormattedMessage id="no_account" defaultMessage={"Don't have an account?"} /> <Link to={"/register"}><span className=" underline cursor-pointer font-medium text-primary"><FormattedMessage id="register" defaultMessage={"Register"} /></span></Link>
                            </p>
                        </div>
                    </>
                </Form>
            )}
        </Formik>
    );
};

export default Login;
